import src from "IMAGE";
export default { src, width: 48, height: 48, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAARklEQVR42q2NwQpAERBFZ8abt6GUrQ1Fif+x9/8/wUpWLDh1N7dTB+A5mlD6jywC4DwNoY5MLoxlFrGpvxYWaSvkVTgmruie9gUu25yoSQAAAABJRU5ErkJggg=="};
